module.exports = __webpack_public_path__ + "static/img/221_TO8_1944.9b50f10.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/221_TO8_1944.jpg
// module id = tpFs
// module chunks = 0